<template>
  <v-app>
    <component v-bind:is="layout"></component>
    <SnackbarNotification />
  </v-app>
</template>

<script src="./js/generalLayout.js"></script>